import axios from 'axios'
import { store } from '../../../redux'
import * as actions from '../../../redux/features/storefront.redux'

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env

export const storePersonalData = (data): Promise<string> => {
  const country = 'de'
  const dataStorageId = store.getState().storefront.id
  const { minAge, ...storable } = data
  const url = `${REACT_APP_API_GATEWAY}/personal/${country}/${REACT_APP_BACKEND_BRAND}/journey/${dataStorageId}`
  return axios.patch(url, storable).then(response => {
    // Update Redux state with the data returned from the service.
    store.dispatch(actions.done(response.data))
    return response.data.id
  })
}
